import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import {
  StandaloneIcon,
  WarningMessageModal,
  MenuOptions,
  Helper
} from "Components";
import "./PowerTableRight.css";
import DeletionContext from "src/MultiDeletionFunctionality/@state/DeletionStateContext";

const PowerTableRight = props => {

  const { deletionState } = useContext(DeletionContext);
  const [isWarningMessageOpen, setOpenWarningMessage] = useState(false);
  const [showProceedButton, setShowProceedButton] = useState(true);

  const [menuOptionCode, setOptionCode] = useState("");
  const [section, setSectionName] = useState("");
  const handleProceed = () => {
    props.onOptionClick(menuOptionCode, props.powerTableIndex);
    setOpenWarningMessage(false);
    setShowProceedButton(true);
  };
  const handleCancle = () => {
    setOpenWarningMessage(false);
    setShowProceedButton(true);
  };
  const handlOnClick = (optionCode, tableIndex) => {
    // eslint-disable-next-line
    if (
      optionCode === "newSubmission" &&
      props.data[tableIndex].NotActiveQuote
    ) {
      setSectionName("newSubmission");
      setShowProceedButton(false);
      setOpenWarningMessage(true);
      setOptionCode(optionCode);
      return;
    }
    // eslint-disable-next-line
    if (optionCode === "newTemplate" && props.data[tableIndex].NotActiveQuote) {
      setSectionName("newTemplate");
      setOpenWarningMessage(true);
      setShowProceedButton(false);

      setOptionCode(optionCode);
      return;
    }
    if (
      ((((props.code === "orders" || props.code === "supplies") &&
        optionCode === "copy") ||
        (props.code === "templates" && optionCode === "newOrder") ||
        (props.code === "jobs" && optionCode === "newOrder")) &&
        props.isSupplyWarningON === "ON" && !props.isPrepaid) ||
      ((((props.code === "orders" || props.code === "supplies") &&
        optionCode === "newTemplate") ||
        (props.code === "templates" && optionCode === "copy") ||
        (props.code === "jobs" && optionCode === "newTemplate")) &&
        props.isTemplateWarningON === "ON") ||
      ((((props.code === "orders" || props.code === "supplies") &&
        optionCode === "newSubmission") ||
        (props.code === "jobs" && optionCode === "newSubmission") ||
        (props.code === "templates" && optionCode === "newSubmission")) &&
        props.isSubmissionWarningON === "ON")
    ) {
      if (
        ((props.code === "orders" || props.code === "supplies") &&
          optionCode === "copy") ||
        (props.code === "jobs" && optionCode === "newOrder") ||
        (props.code === "templates" && optionCode === "newOrder")
      ) {
        setSectionName("Supply");
      } else if (
        ((props.code === "orders" || props.code === "supplies") &&
          optionCode === "newTemplate") ||
        (props.code === "jobs" && optionCode === "newTemplate") ||
        (props.code === "templates" && optionCode === "copy")
      ) {
        setSectionName("Template");
      } else if (
        ((props.code === "orders" || props.code === "supplies") &&
          optionCode === "newSubmission") ||
        (props.code === "jobs" && optionCode === "newSubmission") ||
        (props.code === "templates" && optionCode === "newSubmission")
      ) {
        setSectionName("Submission");
      }
      setOptionCode(optionCode);
      setOpenWarningMessage(true);
    } else {
      props.onOptionClick(optionCode, tableIndex);
    }
  };
  return (
    <div>
      <div className="power-table-right" ref={props.rightRef}>
        <div className="power-table-right__inner">
          <div className="power-table-right__body">
            {props.data.map((row, i) => {
              const hasMenuOptions = props.menuOptions.filter(option =>
                props.rowRules(option, row, props.userName, deletionState.userInfo)).length > 0;

              return <div key={i} className="power-table-right__menu">
                {i === props.powerTableIndex &&
                  !deletionState.isDeletionModeActive &&
                  <MenuOptions
                    menuOptions={props.menuOptions.filter(option =>
                      props.rowRules(option, row, props.userName, deletionState.userInfo)
                    )}
                    onOptionClick={code => handlOnClick(code, i)}
                  />}
                <Helper text={props.moreVertHelperText}>
                  <StandaloneIcon
                    onClick={() =>
                      props.setPageState({
                        powerTableIndex: props.powerTableIndex === i ? null : i,
                        powerTableViewCode: props.viewCode
                      })}
                    icon="more_vert"
                    disabled={!hasMenuOptions}
                    notAllowed={!hasMenuOptions}
                  />
                </Helper>
              </div>
            }
            )}
          </div>

          <div className="power-table-right__head">
            {/* TODO:// Fix this tutorials */}
            {/* <Helper text={i18n.t('tutorials:common.1')} placement="bottom-left"> */}
            <StandaloneIcon
              onClick={() =>
                props.setAppState({ settingTableCode: props.viewCode })}
              icon="settings"
            />
            {/* </Helper> */}
          </div>
        </div>
      </div>
      <div>
        {isWarningMessageOpen &&
          <WarningMessageModal
            onProceed={handleProceed}
            onCancel={handleCancle}
            showProceedButton={showProceedButton}
            section={section}
          />}
      </div>
    </div>
  );
};

PowerTableRight.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
  menuOptions: PropTypes.arrayOf(PropTypes.shape({})),
  rightRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  setAppState: PropTypes.func,
  setPageState: PropTypes.func,
  powerTableIndex: PropTypes.number,
  viewCode: PropTypes.string,
  onOptionClick: PropTypes.func,
  rowRules: PropTypes.func,
  moreVertHelperText: PropTypes.string,
  userName: PropTypes.string,
  isSupplyWarningON: PropTypes.bool,
  code: PropTypes.string,
  isTemplateWarningON: PropTypes.bool,
  isSubmissionWarningON: PropTypes.bool
};

PowerTableRight.defaultProps = {
  rowRules: () => true,
  moreVertHelperText: ""
};

export default PowerTableRight;



// WEBPACK FOOTER //
// ./src/components/PowerTable/PowerTableRight/PowerTableRight.jsx